import 'babel-polyfill';
import React, { Component } from 'react';
import './CreditCard.scss';
import creditCardService from '../../services/creditCardService';
import languageService from '../../services/languageService';
import parameterService from '../../services/parameterService';
import PaymentChooser from '../PaymentChooser/PaymentChooser';
import paymentService from '../../services/paymentService';
import config from '../../data/config';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import ExpiryInput from './ExpiryInput'
import CvcInput from './CvcInput'
import CardHolderNameInput from './CardHolderNameInput'
import { isValidCardHolderName } from '../../utils/isValidCardHolderName';
import PayButtons from '../PayButtons/PayButtons';

const creditCardTypes = creditCardService.getCreditCardTypes();
const isGlobalBrandPreferred = config.templateName.includes('globalBrandPreferred');

class CreditCard extends Component {
    constructor(props) {
        super(props);

        const prefillData = parameterService.prefillData;

        const prefill = (prefillData.MaskedNumber.length > 0) ? true : false;
        const _expirationDate = (prefillData.ExpiryMonth.length > 0 && prefillData.ExpiryYear.length > 0) ? prefillData.ExpiryMonth + prefillData.ExpiryYear.substr(2, 2) : '';
        const cardHolder = (prefillData.Cardholder.length > 0) ? prefillData.Cardholder : '';
        const selectedCard = creditCardTypes.filter(x => x.apiType == 'CC_' + prefillData.Brand)[0];

        this.onPaymentMeanChange = props.onPaymentMeanChange instanceof Function ? props.onPaymentMeanChange : null;
        this.state = {
            error: null,
            cardNumberError: false,
            cardNumberErrorMessage: languageService.texts.cardNumber,
            expMonthErrorMessage: languageService.texts.expMonth + ' / ' + languageService.texts.expYear,
            creditCards: this.getAvailableCards(),
            selectedCard: selectedCard,
            cvcErrorMessage: null,
            isCoBadgedCard: false,
            validCredentials: false,
            isCoBadgedEnabled: creditCardService.isCoBadgedEnabled(),
            showInitialError: true,
            isKeyUp: prefill,
            /** expiration date */
            _expirationDate: _expirationDate,
            /** expiration validation error */
            _expirationDateError: false,
            /** user has entered a cvc code */
            hasEnteredCvc: false,
            /** credit card holder name */
            cardHolder: cardHolder,
            cardHolderError: false,
            cvcError: false,
            prefill: prefill
        };
    }

    getAvailableCards() {
        const availableCards = JSON.parse(JSON.stringify(creditCardTypes));
        availableCards.forEach(ele => ele.active = false);
        return JSON.parse(JSON.stringify(availableCards));
    }

    getCardCredentials(prefill) {
        const { _expirationDate, cardHolder } = this.state;

        const prefillData = parameterService.prefillData;
        let cardNumberInputValue = document.getElementById('cardNumber').value;

        if (prefill === false) {
            
            const maskedNumber = prefillData.MaskedNumber;

            if (maskedNumber > cardNumberInputValue) {
                cardNumberInputValue = '';
            }
            else {
                cardNumberInputValue = cardNumberInputValue.replace(maskedNumber, '');
            }
        } else if (this.state.prefill) {
            cardNumberInputValue = prefillData.CardNumber;
        }

        const cardNumber = cardNumberInputValue;
        const expiration = _expirationDate;
        const expMonth = _expirationDate.substr(0, 2);
        const expYear = _expirationDate.substr(2, 2);
        const checkNumber = document.getElementById('checkNumber').value;
        const saveCardNumber = document.getElementById('prefill');

        return {
            cardNumber,
            cardHolder,
            expiration,
            expMonth,
            expYear,
            checkNumber,
            brand: this.state.selectedCard ? this.state.selectedCard.apiType : null,
            saveCardNumber: saveCardNumber.checked == true ? "on" : ""
        };
    }

    setCardNumber(cardNumber, cursorIndex) {
        const input = document.getElementById('cardNumber');

        input.value = cardNumber;
        input.setSelectionRange(cursorIndex, cursorIndex);
    }

    onCardChange = event => {

        if (this.state.prefill) {
            this.setState({
                prefill: false,
            });
        }

        const cardCredentials = this.getCardCredentials(false);

        let currentCardNumber = cardCredentials.cardNumber;
        const cleanedCardNumber = creditCardService.cleanCardNumber(currentCardNumber);
        let cardNumber = creditCardService.insertSpacesToCardNumber(cleanedCardNumber);
        let currentCursorIndex = event.target.selectionStart;

        const prevIndexChar = cardNumber[currentCursorIndex - 1];
        const isShorter = cardNumber.length < currentCardNumber.length;

        // de- or increase the index
        if (prevIndexChar === ' ' && !isShorter) {
            currentCursorIndex++;
        }

        this.setCardNumber(cardNumber, currentCursorIndex);

        this.setState({
            isKeyUp: !!event.target.value.length
        });


        this.setState({
            validCredentials: this.credentialsAreValid(cardCredentials),
            cardNumberError: false,
            showInitialError: false
        });

        let isCoBadgedCard = false;

        if (this.state.isCoBadgedEnabled) {
            isCoBadgedCard = creditCardService.isCoBadgedCard(cleanedCardNumber);

            if (isCoBadgedCard !== this.state.isCoBadgedCard) {
                this.setState({
                    selectedCard: null
                });
            }

            this.setState({
                isCoBadgedCard: isCoBadgedCard
            });
        }

        const possibleCardTypes = creditCardService.getMatchingBrands(cleanedCardNumber).map(ele => ele.type);

        if (cleanedCardNumber.length === 0) {
            this.setState({
                selectedCard: null,
                error: null,
                creditCards: this.getAvailableCards()
            });
            return;
        }

        if (possibleCardTypes.length !== 1) {
            this.setState({
                selectedCard: null,
                error: null,
                creditCards: this.getAvailableCards()
            });
            return;
        }

        for (let x = 0; x < this.state.creditCards.length; x++) {
            const creditCard = this.state.creditCards[x];

            creditCard.active = possibleCardTypes.filter(ele => ele === creditCard.type).length;
        }

        if (possibleCardTypes.length > 0) {
            this.setState({
                error: null
            });

            if (!isCoBadgedCard || isGlobalBrandPreferred) {
                this.setState({
                    selectedCard: creditCardTypes.filter(ele => ele.type === possibleCardTypes[0])[0]
                });
            } else if (isCoBadgedCard) {
                this.selectCoBadgedCard(true);
            }
        }
    };

    onCheckNumberKeyUp = event => {
        const checkNumber = this.getCardCredentials().checkNumber;

        this.setState({
            hasEnteredCvc: !!checkNumber.length,
            cvcError: false,
            validCredentials: this.credentialsAreValid(this.getCardCredentials()),
            showInitialError: false,
            cvcErrorMessage: this.checkMessageOfCVC(true)
        });
    };

    onExpiryBlur = () => {
        const val = this.state._expirationDate.replace(/\D/g, '');

        if (val.length > 0 && val.length !== 4) {
            this.setState({
                _expirationDateError: true,
                expMonthErrorMessage: this.checkMessageOfExpiryDate(false)
            });
        }
        this.onCardBlur();
    };

    onCvcBlur = (e) => {
        const val = e.target.value;
        let valid = val.length === 0 || val.length === 3;

        if (this.state.selectedCard && this.state.selectedCard['codeLength'] === 4) {
            valid = val.length === 0 || val.length === 4;
        }

        this.setState({
            cvcError: !valid,
            hasEnteredCvc: val.length > 0,
            cvcErrorMessage: this.checkMessageOfCVC(valid)
        });

        this.onCardBlur();
    };

    onCardBlur = () => {
        const { cardNumber, cardHolder } = this.getCardCredentials();
        const {
            incorrectCardNumber
        } = languageService.texts.error;

        this.setState({
            validCredentials: this.credentialsAreValid(this.getCardCredentials())
        });

        if (cardHolder && cardHolder.length >= 2) {
            this.setState({
                cardHolderError: !isValidCardHolderName(cardHolder)
            });
        } else {
            this.setState({
                cardHolderError: null
            });
        }

        //no card number provided
        if (cardNumber.length === 0) {
            this.setState({
                cardNumberError: false,
                error: null,
            });
            return;
        }

        if (!creditCardService.checkCardNumber(cardNumber) && !this.state.prefill) {
            this.setState({
                cardNumberError: true,
                error: 'cardNumberError',
                cardNumberErrorMessage: incorrectCardNumber
            });
            return;
        } else {
            this.setState({
                cardNumberError: false,
                cardNumberErrorMessage: languageService.texts.cardNumber
            });
        }

        const possibleCardTypes = creditCardService.getMatchingBrands(cardNumber).map(ele => ele.type);

        // @todo: check if we can use the following statement
        // if (this.state.creditCards.length > 0 && !this.state.selectedCard)
        if (!this.state.selectedCard && this.state.isCoBadgedCard) {
            this.setState({
                error: 'noCardSelected'
            });
        } else if (this.state.creditCards.length === 0 && possibleCardTypes.length === 0 && !this.state.isCoBadgedCard) {
            this.setState({
                error: 'notSupportedBrand'
            });
        } else {
            this.setState({
                error: null
            });
        }
    };

    credentialsAreValid(cardCredentials = this.getCardCredentials()) {
        const { _expirationDateError, cardHolder } = this.state;
        const expiration = this.splitExpDate(cardCredentials.expiration);

        const cardNumberValid = (!this.state.prefill) ? creditCardService.checkCardNumber(cardCredentials.cardNumber) : true;
        const expMonthValid = creditCardService.checkExpMonth(expiration.expMonth);
        const expYearValid = creditCardService.checkExpYear(expiration.expYear);
        const checkNumberValid = creditCardService.checkCheckNumber(cardCredentials.checkNumber);
        const cardBrandValid = !!this.state.selectedCard;
        const cardholderValid = isValidCardHolderName(cardHolder);
        return cardholderValid && cardNumberValid && !_expirationDateError && expMonthValid && expYearValid && checkNumberValid && cardBrandValid;
    }

    selectCardBrand = type => {
        const selectedCard = this.state.creditCards.filter(ele => ele.type === type)[0];
        if (!selectedCard.active) {
            return;
        }

        // clear error message for no card brand selected
        if (this.state.error === 'noCardSelected') {
            this.setState({
                error: null
            });
        }

        this.setState({
                selectedCard: selectedCard
            },
            () => {
                this.setState({
                    validCredentials: this.credentialsAreValid(this.getCardCredentials()),
                });
            }
        );
    };

    selectCoBadgedCard = (force) => {
        if (!force && !this.state.isCoBadgedCard) {
            return;
        }

        // clear error message for no card brand selected
        if (this.state.error === 'noCardSelected') {
            this.setState({
                error: null
            });
        }

        this.setState({
                selectedCard: {
                    "type": "co-badged",
                    "name": "Cartes Bancaires",
                    "apiType": "CC_Cartes Bancaires",
                    "logo": "cartesbancaires.png",
                    "codeName": "cvc",
                    "codeLength": 3
                }
            },
            () => {
                this.setState({
                    validCredentials: this.credentialsAreValid(this.getCardCredentials()),
                });
            }
        );
    };

    payNow = event => {
        const cardCredentials = this.getCardCredentials();

        if (!this.credentialsAreValid(cardCredentials)) {
            console.log('pay now exception');
            return;
        }

        event.target.disabled = true;
        paymentService.creditCardPayment(cardCredentials, config.variationName);
    };

    splitExpDate = value => {
        const expiration = value.replace(/[^0-9]+/g, "");

        let expMonth, expYear;
        if (expiration.length <= 2) {
            expMonth = expiration;
            expYear = '';
        } else {
            expMonth = expiration.substring(0, 2);
            expYear = expiration.slice(2);
        }

        return {
            expMonth,
            expYear
        }
    };

    checkMessageOfExpiryDate(valid) {
        const {
            incorrectExpiry
        } = languageService.texts.error;

        if (!valid) {
            return incorrectExpiry;
        }

        return languageService.texts.expMonth + ' / ' + languageService.texts.expYear;
    }

    checkMessageOfCVC(valid) {
        const {
            incorrectCvc
        } = languageService.texts.error;
        const standardMessage = languageService.texts.cvc;

        if (!valid) {
            return incorrectCvc + standardMessage;
        }

        return standardMessage;
    }

    componentDidMount() {

        if (this.state.prefill) {
            const prefillData = parameterService.prefillData;

            this.setCardNumber(prefillData.MaskedNumber, 0);
            document.getElementById('checkNumber').focus();
        } else {
            this.creditCardInputRef.focus();
        }
    };

    render() {
        const { _expirationDate, _expirationDateError, hasEnteredCvc, cvcError } = this.state;

        return (
            <div className="row">
                <div className="CreditCard">
                    <div className="creditcard-container">
                        <PayButtons/>
                        <h2 className="headline">
                            {languageService.texts.pleaseCardData}
                        </h2>
                        <div className={"card-options justify-content-center align-content-center flex-wrap " +
                        (this.state.creditCards.filter(card => card.active).length ? 'cards-available' : '')
                        }>
                            {this.state.isCoBadgedEnabled && (
                                <div className={'card-brand' + (this.state.isCoBadgedCard ? ' active' : '')
                                + ('co-badged' === (this.state.selectedCard && this.state.selectedCard.type) ? ' selected' : '')}
                                     key="Cartes Bancaires"
                                     onClick={() => this.selectCoBadgedCard()}>
                                    <img src={config.imageUrl + 'cartesbancaires.png'} alt="Cartes Bancaires"/>
                                </div>)}
                            {this.state.creditCards.map(creditCard => {
                                return (
                                    <div className={"card-brand" + (creditCard.active ? ' active' : '')
                                    + (creditCard.type === (this.state.selectedCard && this.state.selectedCard.type) ? ' selected' : '')}
                                         key={creditCard.name}
                                         onClick={() => this.selectCardBrand(creditCard.type)}>
                                        <img src={config.imageUrl + creditCard.logo} alt={creditCard.name}/>
                                    </div>
                                )
                            })}
                        </div>
                        {false && this.state.showInitialError &&
                        <ErrorMessage/>
                        }
                        {false && !this.state.showInitialError && this.state.error &&
                        <div className="form-error">
                            <div className="form-error-msg">
                                {languageService.texts.error[this.state.error]}
                            </div>
                        </div>
                        }
                        <form className="card-form">
                            <div className="credentials d-flex flex-wrap">
                                <div
                                    className={'card-number form-group' + (this.state.cardNumberError ? ' error' : '') + ' ' + (this.state.isKeyUp ? 'isKeyUp' : 'noKeyUp')}>
                                    <label htmlFor="cardNumber">
                                        {(this.state.cardNumberErrorMessage ? this.state.cardNumberErrorMessage : languageService.texts.cardNumber)}
                                    </label>
                                    <div className="input-container">
                                        <input ref={(input) => {
                                            this.creditCardInputRef = input;
                                        }} className="form-control" type="text" id="cardNumber" inputMode="numeric"
                                               pattern="\d*"
                                               onChange={this.onCardChange}
                                               onBlur={this.onCardBlur} placeholder={languageService.texts.cardNumber}
                                               autoComplete="cc-number"
                                               autoCorrect="off"
                                               spellCheck="false"

                                        />
                                        {this.state.selectedCard && (
                                            <div className="addon-icon selected" key={this.state.selectedCard.name}>
                                                <img src={config.imageUrl + this.state.selectedCard.logo}
                                                     alt={this.state.selectedCard.name}/>
                                            </div>)
                                        }
                                    </div>
                                </div>

                                <div className="card-credentials">
                                    <div className="credentials-container">
                                        <div className={
                                            [
                                                'credential',
                                                'credentials-month',
                                                !_expirationDate ? 'is-empty' : null
                                            ].join(' ')
                                        }>
                                            <div className={'form-group' + (_expirationDateError ? ' error' : '')}>
                                                <label htmlFor="expMonth" className="text-nowrap">
                                                    {(this.state.expMonthErrorMessage ? this.state.expMonthErrorMessage : languageService.texts.expMonth + ' / ' + languageService.texts.expYear)}
                                                </label>
                                                <ExpiryInput onBlur={this.onExpiryBlur} onChange={({ raw, valid }) => {
                                                    this.setState({
                                                        _expirationDate: raw,
                                                        _expirationDateError: !valid,
                                                        expMonthErrorMessage: this.checkMessageOfExpiryDate(valid)
                                                    }, () => {
                                                        this.onCardBlur();
                                                    })
                                                }}/>
                                            </div>
                                        </div>
                                        <div className={
                                            [
                                                'credential',
                                                'credentials-check-number',
                                                !hasEnteredCvc ? 'is-empty' : ''
                                            ].join(' ')
                                        }>
                                            <div className={[
                                                "form-group",
                                                cvcError ? 'error' : ''
                                            ].join(' ')}>
                                                <label htmlFor="checkNumber" className="text-nowrap">
                                                    {(this.state.cvcErrorMessage ? this.state.cvcErrorMessage : languageService.texts.cvc)}
                                                </label>
                                                <CvcInput onChange={this.onCheckNumberKeyUp}
                                                          onBlur={this.onCvcBlur}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div className="row">

                                <div
                                    className={['credential', 'credential-cardholder', this.state.cardHolder.length === 0 ? 'is-empty' : ''].join(' ')}>

                                    <div className={"form-group" + (this.state.cardHolderError ? ' error' : '')}>
                                        <CardHolderNameInput
                                            id="cardholderName"
                                            error={(() => {
                                                const isError = this.state.cardHolderError;
                                                const tooShort = this.state.cardHolder.length < 2;
                                                const tooLong = this.state.cardHolder.length > 45;
                                                const forbiddenChars = isError && !tooLong && !tooShort;

                                                const {
                                                    cardHolderTooShort,
                                                    cardHolderTooLong,
                                                    cardHolderContainsSpecialChars
                                                } = languageService.texts.error;

                                                switch (true) {
                                                    case isError && forbiddenChars:
                                                        return cardHolderContainsSpecialChars;
                                                    case isError && tooShort:
                                                        return cardHolderTooShort;
                                                    case isError && tooLong:
                                                        return cardHolderTooLong;
                                                }
                                            })()}
                                            placeholder={languageService.texts.nameOnCard}
                                            onBlur={this.onCardBlur}
                                            onChange={cardHolder => {
                                                this.setState({ cardHolder }, () => {
                                                    this.onCardBlur();
                                                });
                                            }}/>
                                    </div>

                                </div>

                            </div>
                            <div className="row" style={{alignItems: "center", height: "24px", display: parameterService.data.saveCardData}}>
                                <div className="col-12">
                                    <input type="checkbox" id="prefill" name="prefill"/>
                                    <label htmlFor="prefill" style={{marginBottom: "0px", marginLeft: "5px", cursor: "pointer"}}>{languageService.texts.saveCardData}</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 pay-button-col text-right">
                                    <button
                                        type="button"
                                        className="pay-btn btn btn-primary btn-block"
                                        disabled={!this.state.validCredentials}
                                        onClick={this.payNow}>
                                        {languageService.texts.pay} {parameterService.data.amount && parameterService.data.amount + ' '} {languageService.texts.now}
                                    </button>
                                </div>
                            </div>
                        </form>
                        {(this.onPaymentMeanChange instanceof Function && !parameterService.includesOnlyCreditCards()) &&
                        <PaymentChooser onPaymentMeanChange={this.onPaymentMeanChange} excludes={['credit-card', 'googlepay', 'applepay']}/>}
                        {this.state.isCoBadgedCard && this.state.selectedCard && <div
                            className="my-4 text-center d-sm-block selected-card-text">{languageService.translate('selectedCardText', { 'cardName': this.state.selectedCard.name })}</div>}
                    </div>
                </div>
            </div>
        );
    }
}

export default CreditCard;


// WEBPACK FOOTER //
// ./src/components/CreditCard/CreditCard.js